import moment from 'moment'

import { DMY_CASUAL_SHORT_FORMAT, SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { max, unique } from 'lib/array/arrayUtils'
import { pluralizeToString } from 'lib/string/pluralize'

export interface TourV2SnapshotDetails {
  countriesCount?: string
  placesCount?: string
  date: string | null
  formattedEndDate: string | null
  formattedStartDate: string | null
  daysCount?: string
  hasTheSameStartAndEndLocation?: boolean
}

function extractTourV2SnapshotDetails(snapshot: App.Tours.TourV2OfferSnapshot | undefined): TourV2SnapshotDetails {
  if (!snapshot?.itineraries?.length) {
    return {
      date: null,
      formattedStartDate: null,
      formattedEndDate: null,
      daysCount: undefined,
      countriesCount: undefined,
      placesCount: undefined,
      hasTheSameStartAndEndLocation: undefined,
    }
  }

  const lastDay = max(snapshot.itineraries, (item) => item.startDay)! // An itinerary will exist
  const daysCount = lastDay.startDay + lastDay.duration - 1
  const uniquePlaces = getTourV2PlacesVisited(snapshot.itineraries)

  return {
    date: snapshot ? `${moment(snapshot.startDate).format(DMY_CASUAL_SHORT_FORMAT)} - ${moment(snapshot.endDate).format(DMY_CASUAL_SHORT_FORMAT)}` : null,
    formattedStartDate: snapshot ? moment(snapshot.startDate).format(SHORT_DAY_NAME_DAY_MONTH_YEAR) : null,
    formattedEndDate: snapshot ? moment(snapshot.endDate).format(SHORT_DAY_NAME_DAY_MONTH_YEAR) : null,
    hasTheSameStartAndEndLocation: snapshot.startLocation === snapshot.endLocation,
    daysCount: snapshot ? pluralizeToString('day', daysCount) : undefined,
    countriesCount: snapshot.countriesVisited.length ? pluralizeToString('country', snapshot.countriesVisited.length) : undefined,
    placesCount: uniquePlaces.length ?
        pluralizeToString('place', uniquePlaces.length) : undefined,
  }
}

export function getTourV2PlacesVisited(itinerary: Array<App.Tours.TourV2OfferItineraryItem>): Array<string> {
  return unique(itinerary.flatMap(item => item.locationsVisited))
}

export default extractTourV2SnapshotDetails
